
import { Folder } from "@/models/tasks/folder";
import { Task } from "@/models/tasks/task";
import { TaskService } from "@/services/task-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { TasksState } from "../../utils/tasks-state";
import AppTaskEdit from "./TaskEdit.vue";

export default FormLike.extend({
	props: {
		value: {
			type: Object as () => Task,
			required: true
		},
		folder: {
			type: Object as () => Folder,
			required: true
		},
		state: {
			type: Object as () => TasksState,
			required: true
		}
	},
	computed: {
		title(): string {
			if (this.value.ID == 0) {
				return this.$ct("create-task").toString();
			}
			return this.$ct("edit-task").toString();
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async submit() {
			this.validate();
			if (!this.isValid) {
				return;
			}
			if (this.value.ID == 0) {
				await TaskService.postTask(this.value);
			} else {
				await TaskService.putTask(this.value);
			}
			this.$emit("saved");
			this.close();
		},
	},
	components: {
		AppTaskEdit
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
